import React from 'react';
import { FormControlLabel, Switch, Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import i18next from 'i18next';

/**
 * SwitchInput Component
 * A reusable switch input component for forms
 */
const SwitchInput = ({
    label,
    name,
    checked = false,
    onChange,
    disabled = false,
    helperText,
    ...rest
}) => {
    const theme = useTheme();
    const lng = i18next.language || 'en';
    const isArabic = lng.startsWith('ar');

    return (
        <Box sx={{ width: 'fit-content' }}>
            <FormControlLabel
                control={
                    <Switch
                        checked={checked}
                        onChange={onChange}
                        name={name}
                        disabled={disabled}
                        color="primary"
                        {...rest}
                    />
                }
                label={
                    <Typography
                        variant="body1"
                        sx={{
                            fontWeight: 500,
                            color: theme.palette.text.primary
                        }}
                    >
                        {label}
                    </Typography>
                }
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginLeft: 0,
                    marginRight: 0,
                    width: '100%',
                    direction: isArabic ? 'rtl' : 'ltr',
                }}
            />

            {helperText && (
                <Typography
                    variant="caption"
                    sx={{
                        display: 'block',
                        mt: 0.5,
                        color: theme.palette.text.secondary,
                        textAlign: isArabic ? 'right' : 'left',
                    }}
                >
                    {helperText}
                </Typography>
            )}
        </Box>
    );
};

export default SwitchInput;
